/* eslint-disable import/prefer-default-export */
export enum ProjectRole {
  OWNER = 'OWNER',
  USER = 'MEMBER',
}

export enum RoleCode {
  EDITOR_WITH_BILLING = 'EDITOR_WITH_BILLING',
  EDITOR_NO_BILLING = 'EDITOR_NO_BILLING',
  VIEWER_WITH_BILLING = 'VIEWER_WITH_BILLING',
  VIEWER_NO_BILLING = 'VIEWER_NO_BILLING',
  FINANCE = 'FINANCE',
}

export enum ServicePermissions {
  NETWORK = 'NETWORK',
  S3 = 'S3',
  TWO_FACTOR_AUTH = 'TWO_FACTOR_AUTH',
  PROJECT_MANAGEMENT = 'PROJECT_MANAGEMENT',
  USER_SETTINGS = 'USER_SETTINGS',
  ACCESS_KEYS = 'ACCESS_KEYS',
  LOAD_BALANCERS = 'LOAD_BALANCERS',
  VIRTUAL_SERVERS = 'VIRTUAL_SERVERS',
  BACKUPS = 'BACKUPS',
  AUDIT_LOG = 'AUDIT_LOG',
  AUTO_SCALING_GROUPS = 'AUTO_SCALING_GROUPS',
  NOTIFICATION_SETTINGS = 'NOTIFICATION_SETTINGS',
  ALERTS = 'ALERTS',
  RESOURCE_DISTRIBUTION = 'WRITE',
  SECURITY_GROUPS = 'SECURITY_GROUPS',
  DISKS = 'DISKS',
  DASHBOARD = 'DASHBOARD',
  KUBERNETES = 'KUBERNETES',
  PASSWORD_CHANGE = 'PASSWORD_CHANGE',
  CUSTOM_IMAGES = 'CUSTOM_IMAGES',
  CONSUMPTION = 'CONSUMPTION',
  USER_MANAGEMENT = 'USER_MANAGEMENT',
  MANAGED_DATABASES = 'MANAGED_DATABASES',
  ROUTERS = 'ROUTERS',
}

export enum PermissionLevel {
  READ = 'READ',
  WRITE = 'WRITE',
}

export type UserProjectPermissions = Partial<Record<ServicePermissions, PermissionLevel>>;
